import { render, staticRenderFns } from "./PluginScreenshots.vue?vue&type=template&id=855178d6&"
import script from "./PluginScreenshots.vue?vue&type=script&lang=js&"
export * from "./PluginScreenshots.vue?vue&type=script&lang=js&"
import style0 from "./PluginScreenshots.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports